import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'page-not-available',
    templateUrl: './page-not-available.component.html',
    standalone: false
})
export class PageNotAvailableComponent {
}
